import React, { type RefObject } from "react";
import type { ScrollView } from "tamagui";
import { log } from "../../ui/log";

let staticScrollViewRef: RefObject<ScrollView | null> =
  React.createRef<ScrollView>();

export function setScrollViewRef(ref: RefObject<ScrollView>) {
  staticScrollViewRef = ref;
}

export function scrollToTop(animated = false) {
  if (staticScrollViewRef.current) {
    staticScrollViewRef.current.scrollTo({ y: -10000, animated });
  } else {
    log.dev("Could not scrollToTop!");
  }
}
